export default __webpack_public_path__ + "static/media/tick.3667f989.svg";